import styled from "styled-components";

export const ServicesContainer = styled.div`
  /* border-top: solid black 6px; */
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* m  argin-top:100px; */
  /* background: rgb(1, 6, 6); */
  /* background: linear-gradient(0.25turn, #4c1109, #a0410f, #4c1109); */
  background: linear-gradient(
    180deg,
    rgba(45, 38, 67, 1) 100%,
    rgba(0, 0, 0, 255) 17%,
    rgba(9, 9, 121, 1) 39%
  );
  @media screen and (max-width: 768px) {
    height: auto;
  }

  @media screen and (max-width: 480px) {
    height: auto;
  }
`;

export const Welcome = styled.div`
  justify-content: center;
  align-items: center;
  width: 90%;
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const DirectionFlex = styled.div`
  flex-direction: row;
`;
export const ChicksWorld = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;

`;
export const WorldCont = styled.div`
  width: 60%; 
  padding: 1rem;
  @media screen and (max-width:768px) {
    width: 100%;
  }
`;
export const Heading = styled.h1`
  margin-bottom: 24px;
  font-size: 3vw;
  display: inline-flex;
  color: white;
  justify-content: center;
  display: flex;
  font-family: "honeybear";
  margin-top: 2%;
  line-height: 1.1;

  @media screen and (max-width: 768px) {
    font-size: 28px;
    justify-content: center;
    display: flex;
    width: 100%;
    text-align: center;
    line-height: 1.5;
    margin-top: 20px;
  }
`;
export const Headingtt = styled.h1`
  margin-bottom: 24px;
  font-size: 2vw;
  display: inline-flex;
  color: white;
  justify-content: center;
  display: flex;
  font-family: "honeybear";
  margin-top: 2%;
  line-height: 1.1;

  @media screen and (max-width: 768px) {
    font-size: 28px;
    justify-content: center;
    display: flex;
    width: 100%;
    text-align: center;
    line-height: 1.5;
    margin-top: 20px;
  }
`;
export const Heading1 = styled.h1`
  margin-bottom: 24px;
  font-size: 64px;
  color: #e4a300;
  font-family: "Bangers", cursive;
  line-height: 1.1;
  font-weight: 600;
  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;
export const Subtitle = styled.p`
  margin-bottom: 35px;
  font-size: 1.3vw;
  /* text-align: center; */
  line-height: 28px;
  /* text-transform: uppercase; */
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 3.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
`;
export const CenterSubtitle = styled.p`
 /* margin-bottom: 35px; */
 font-size: 2.5vw;
 /* line-height: 3rem; */
 font-family: "poppins";
 color: white;
  @media screen and (max-width: 768px) {
    font-size: 5.5vw;
    line-height: 3rem;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
  
`;
export const CenterCont = styled.div`
  width: 56%;
  align-items: center;
  display: flex;
  justify-content: center;
  /* margin-top: 3rem; */
  @media screen and (max-width: 768px) {
    width: 90%;
    margin-top: 0rem !important;
  }
  
`;
export const WorldSubtitle = styled.p`
  /* margin-bottom: 35px; */
  font-size: 1.3vw;
  /* text-align: center; */
  line-height: 28px;
  /* text-transform: uppercase; */
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 3.3vw;
    text-align: center;
    margin-bottom: -9px;
  }
`;
export const FamilyHeading = styled.h1`
  font-size: 3vw;
  line-height: 10px;
  /* margin-bottom: 0.7em !important; */
  margin-top: 2rem;
  font-family: "hello";
  display: flex;
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 6vw;
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;
export const FamilyEvenHeading = styled.h1`
  font-size: 3vw;
  line-height: 10px;
  /* margin-bottom: 0.7em !important; */
  margin-top: 2rem;
  font-family: "hello";
  display: flex;
  justify-content: end;
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 6vw;
    line-height: 2rem;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
  }
`;

export const FamiliesSubtitle = styled.p`
  margin-bottom: 0px !important;
  
  font-size: 1.3vw;
  line-height: 28px;
  padding: 0.5rem;
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 3.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
`;
export const FamiliesSubtitleFam = styled.p`
  margin-bottom: 0px !important;
  font-size: 1.5vw;
  line-height: 28px;
  padding: 0.5rem;
  text-align: center;
  font-family: "poppins";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 3.3vw;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
`;
export const Familiesline = styled.p`
  margin-bottom: 0px !important;

  font-size: 4vw;
  /* text-align: center; */
  line-height: 28px;
  /* text-transform: uppercase; */
  font-family: "hello";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 32px;
    line-height: 2.5rem;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 16px;
  }
`;

export const SubtitleSpan = styled.span`
  margin-bottom: 35px;
  font-size: 30px;
  text-align: center;
  line-height: 24px;
  font-family: "Bangers", cursive;
  color: #17112c;
  @media screen and (max-width: 768px) {
    font-size: 17px;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const Subtitle1 = styled.p`
  font-size: 30px;
  line-height: 24px;
  text-align: center;
  font-family: "Bangers", cursive;
  color: #17112c;
  @media screen and (max-width: 768px) {
    font-size: 17px;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const Subtitle1Span = styled.span`
  font-size: 30px;
  line-height: 24px;
  text-align: center;
  font-family: "Bangers", cursive;
  color: #17112c;
  @media screen and (max-width: 768px) {
    font-size: 17px;
    text-align: center;
    margin-left: 10px;
    margin-right: 10px;
  }
`;
export const FamilyContainer = styled.div`
  width: 80%;
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.08);
  direction: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 420px) {
    padding: 1rem !important;
  }
`;
export const Welcomeimg = styled.img`
  /* width: 95%; */
  /* border: 3px solid #828; */
  @media screen and (max-width: 768px) {
    width: 73%;
    /* display: none; */
  }
`;
export const FamilyContainerFam = styled.div`
  width: 90%;
  /* padding: 1rem; */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
      flex-direction: column;
      margin-top: 0rem !important;
    /* display: none; */
  }
`;
export const FamilyContainerFamBot = styled.div`
  width: 60%;
  padding: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    padding: 0rem !important;
    /* display: none; */
  }
`;
export const Nestedimg1 = styled.img`
  /* width: 95%; */
  /* border: 3px solid #828; */
  @media screen and (max-width: 768px) {
    width: 100%;
    /* display: none; */
  }
`;

export const Eggsimg = styled.img`
  /* width: 95%; */
  /* border: 3px solid #828; */
  @media screen and (max-width: 768px) {
    width: 100%;
    /* display: none; */
  }
`;
export const Nestedimg = styled.img`
  /* width: 95%; */
  border: 3px solid #828;
  @media screen and (max-width: 768px) {
    width: 100%;
    /* display: none; */
  }
`;
export const NestedImgCon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

@media screen and (max-width: 768px) {
    /* width: 60%;
    display: none; */
    
  }
`;
export const EggsImgCon = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
`;

export const Welcomeimg1 = styled.img`
  width: 27%;
  display: none;
  @media screen and (max-width: 768px) {
    width: 60%;
    display: block;
  }
`;
export const Familyimg = styled.img`
  width: 15%;
  /* display: none; */
  @media screen and (max-width: 768px) {
    width: 60%;
    display: block;
  }
`;

export const FamilyimgFam = styled.img`
  width: 70%;
  border: 10px solid;
  border-image-slice: 1;
  border-width: 5px;
  border-image-source: linear-gradient(to left, #743ad5, #d53a9d);
  /* display: none; */
  @media screen and (max-width: 768px) {
    width: 60%;
    display: block;
  }
`;
export const GridWelcome = styled.div`
  margin-left: 4rem;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  padding: 1rem;
  width: 90%;
  @media screen and (max-width: 768px) {
    margin-left: 0rem !important;
    width: 100%;
  }
`;
export const HomeDivSub = styled.div`
  width: 100%;
  padding: 1rem; 
  @media screen and (max-width: 768px) {
    width: 90%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`;
export const FamilyInnCont = styled.div`
  /* margin-left: 4rem; */
  align-items: center;
  padding: 1rem;
  margin-top: 0rem;
  background-color: rgba(255, 255, 255, 0.08);
  justify-content: center;
  display: flex;
  flex-direction: row;
  /* padding: 1rem; */
  width: 100%;
  @media screen and (max-width: 768px) {
    align-items: center;
    margin-top: 0rem;
    background-color: rgba(255, 255, 255, 0.08);
    justify-content: center;
    display: flex;
    flex-direction: column;
    /* padding: 1rem; */
    width: 100%;
  }
`;
export const FamilyInnContFam = styled.div`
  align-items: center;
  margin-top: 0rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (max-width: 768px) {
    align-items: center;
    margin-top: 0rem;
    justify-content: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const FamilyInnEvenContFam = styled.div`
  align-items: center;
  margin-top: -2rem;
  justify-content: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media screen and (max-width: 768px) {
    align-items: center;
    margin-top: 0rem;
    justify-content: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const FamilyInnEvenCont = styled.div`
  /* margin-left: 4rem; */
  align-items: center;
  margin-top: 2rem;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.08);
  justify-content: center;
  display: flex;
  flex-direction: row-reverse;
  /* padding: 1rem; */
  width: 100%;
  @media screen and (max-width: 768px) {
    align-items: center;
    margin-top: 2rem;
    background-color: rgba(255, 255, 255, 0.08);
    justify-content: center;
    display: flex;
    flex-direction: column;
    /* padding: 1rem; */
    width: 100%;
  }
`;
export const FamilyTextCont = styled.div`
  /* margin-left: 4rem; */
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: row;
  /* padding: 1rem; */
  width: 100%;
`;
export const marginAdd = styled.div`
  margin-top: 16px;
  @media screen and (max-width: 768px) {
    margin-top: 13px;
  }
`;
export const ImgDiv = styled.div`
  margin-top: 1.4rem;
  width: 32%;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
export const WelImgCont = styled.div`
  display: flex;
  width: 100%;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const WeltextCont = styled.div`
  width: 77%;
  padding: 1rem;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
export const ImgNestedDiv = styled.div`
  width: 30%;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
export const ImgEggsDiv = styled.div`
  width: 13%;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 27%;
  }
  @media screen and (max-width: 480px) {
    width: 47%;
  }
`;
export const WorldImgDiv = styled.div`
  width: 25%;
  justify-content: center;
  @media screen and (max-width: 768px) {
    width: 0;
  }
`;
